/* eslint-disable no-param-reassign */
import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import Feature from "./Feature";
import "../../css/feature.scss";

/**
 * Randomly shuffle an array
 * https://stackoverflow.com/a/2450976/1293256
 * @param  {Array} array The array to shuffle
 * @return {String}      The first item in the shuffled array
 */
const shuffle = (array) => {
  let currentIndex = array.length;
  let temporaryValue
  let randomIndex;

  // While there remain elements to shuffle...
  while (currentIndex !== 0) {
    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;

    // And swap it with the current element.
    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }

  return array;
};

const FeatureList = ({ list }) => {
  const features = [];
  let counter = 1;
  list.forEach((author) => {
    author.blurbs.forEach((feature) => {
      features.push(
        <Feature id={`feature${counter}`}
          data={author}
          feature={feature}
          key={`${author.slug}-${feature.title}`}
        />
      )
      counter += 1;
    })
  });
  const shuffled = shuffle(features);

  const attach = useRef(null);
  useEffect(() => {
    if (window.location.hash === "#features") {
      attach.current.scrollIntoView();
    }
  }, []);

  return (
    <section id="features" ref={attach}>
      {shuffled.map((feature) => (
        feature
      ))}
    </section>
  )
}

FeatureList.propTypes = {
  list: PropTypes.arrayOf(PropTypes.shape({
    slug: PropTypes.string.isRequired,
    blurbs: PropTypes.arrayOf(PropTypes.shape({
      title: PropTypes.string.isRequired
    }))
  }))
}

FeatureList.defaultProps = {
  list: undefined
}

export default FeatureList;
